const messages = {
    en: {
        media: {
            file: {
                title: 'Files',
                dashboardTitle: "File Dashboard",
                subtitle: 'View, search, create, edit and delete File',
                creating: 'Creating File',
                editing: 'Editing File',
                deleting: 'Deleting File',
                showing: 'Showing File',
                filename: 'Filename',
                description: 'Description',
                tags: 'Tags',
                extension: 'Extension',
                relativePath: 'Relative path',
                absolutePath: 'Absolute path',
                type: 'Type',
                text: 'Text',
                image: 'Image',
                application: 'Application',
                audio: 'Audio',
                mimetype: 'mimetype',
                id: 'ID',
                url: 'URL',
                createdAt: 'Creation date',
                download: 'download',
                fileSizeExceeded: "File is too big",
                lastAccess: 'Last access',
                csvEtiquetas: {
                    title: 'Labels',
                    listTitle: 'Available files',
                    lastUpdate: 'Last update',
                    deposito: 'Warehouse',
                    download: 'Download',
                    delete: 'Delete',
                    deleteConfirm: 'Delete this file?',
                    deleted: 'File deleted.',
                    errorDelete: 'Error deleting file.',
                    noCompany: 'Company not selected.',
                    selectDeposito: 'Configure a warehouse in your user settings to see CSV files.',
                    noFiles: 'No CSV files for this warehouse yet. They are generated when you add stock to products.',
                    downloadStarted: 'Download started.',
                    errorConfig: 'Error loading configuration.',
                    errorList: 'Error loading list.',
                    errorToken: 'Error getting download link.',
                    errorDownload: 'Error downloading.',
                    depositoActual: 'Current warehouse',
                },
                filters: 'Filters',
                from: 'From',
                until: 'Until',
                sizeGt: 'Size greater than',
                sizeLt: 'Size less than',
                dashboard: {
                    fileUserMetrics: {
                        title: "File indicators of the last 5 months",
                        countLabel: "File count",
                        sizeLabel: "Size",
                    },
                    almacenamientoPorUsuario: {
                        title: "User storage per user (Mb)",
                        subtitle: "Total size"
                    },
                    cantidadArchivosPorUsuario: {
                        title: "Number of files per user",
                        subtitle: "Number of files"
                    }
                }
            },
        },
    },
    es: {
        media: {
            file: {
                title: 'Archivos',
                dashboardTitle: "Dashboard de Archivos",
                subtitle: 'Ver, buscar, crear, editar, y borrar Archivo',
                creating: 'Creando archivo',
                editing: 'Modificando archivo',
                deleting: 'Eliminando archivo',
                showing: 'Detalles de archivo',
                filename: 'Nombre del archivo',
                description: 'Descripción',
                tags: 'Etiquetas',
                extension: 'Extensión',
                relativePath: 'Ruta relativa',
                absolutePath: 'Ruta absoluta',
                type: 'Tipo',
                text: 'Texto',
                image: 'Imagen',
                application: 'Aplicación',
                audio: 'Audio',
                mimetype: 'mimetype',
                id: 'ID',
                url: 'URL',
                createdAt: 'Fecha de creación',
                download: 'descargar',
                fileSizeExceeded: "Archivo demasiado grande",
                lastAccess: 'Último acceso',
                csvEtiquetas: {
                    title: 'Etiquetas',
                    listTitle: 'Archivos disponibles',
                    lastUpdate: 'Última actualización',
                    deposito: 'Almacén',
                    download: 'Descargar',
                    delete: 'Eliminar',
                    deleteConfirm: '¿Eliminar este archivo?',
                    deleted: 'Archivo eliminado.',
                    errorDelete: 'Error al eliminar el archivo.',
                    noCompany: 'No hay empresa seleccionada.',
                    selectDeposito: 'Configure un almacén en su configuración de usuario para ver los CSV.',
                    noFiles: 'Aún no hay archivos CSV para este almacén. Se generan al agregar stock a productos.',
                    downloadStarted: 'Descarga completada',
                    errorConfig: 'Error al cargar la configuración.',
                    errorList: 'Error al cargar la lista.',
                    errorToken: 'Error al obtener el enlace de descarga.',
                    errorDownload: 'Error al descargar.',
                    depositoActual: 'Almacén actual',
                },
                filters: 'Filtros',
                from: 'Desde',
                until: 'Hasta',
                sizeGt: 'Tamaño mayor a',
                sizeLt: 'Tamaño menor a',
                dashboard: {
                    fileUserMetrics: {
                        title: "Indicadores de archivos de los últimos 5 meses",
                        countLabel: "Cantidad de archivos",
                        sizeLabel: "Peso",
                    },
                    almacenamientoPorUsuario: {
                        title: "Almacenamiento por usuario (Mb)",
                        subtitle: "Peso total"
                    },
                    cantidadArchivosPorUsuario: {
                        title: "Cantidad de archivos por usuario",
                        subtitle: "Cantidad de archivos"
                    }
                }


            },
        }
    },
    pt: {
        media: {
            file: {
                title: 'File',
                dashboardTitle: "Painel de arquivos",
                subtitle: 'Ver, buscar, criar, editar e usar File',
                creating: 'Criando File',
                editing: 'Edição File',
                deleting: 'Apagando File',
                showing: 'Detalhes do File',
                filename: 'Nome do arquivo',
                description: 'Descrição',
                tags: 'Tags',
                extension: 'Extensão',
                relativePath: 'Caminho relativo',
                absolutePath: 'Caminho absoluto',
                type: 'Tipo',
                text: 'Texto',
                image: 'Imagem',
                application: 'Aplicativo',
                audio: 'Áudio',
                mimetype: 'mimetype',
                id: 'ID',
                url: 'URL',
                createdAt: 'Data de criação',
                download: 'download',
                fileSizeExceeded: "Arquivo muito grande",
                lastAccess: 'Último acesso',
                csvEtiquetas: {
                    title: 'Etiquetas',
                    listTitle: 'Arquivos disponíveis',
                    lastUpdate: 'Última atualização',
                    deposito: 'Depósito',
                    download: 'Baixar',
                    delete: 'Excluir',
                    deleteConfirm: 'Excluir este arquivo?',
                    deleted: 'Arquivo excluído.',
                    errorDelete: 'Erro ao excluir o arquivo.',
                    noCompany: 'Nenhuma empresa selecionada.',
                    selectDeposito: 'Configure um depósito nas configurações do usuário.',
                    noFiles: 'Nenhum arquivo CSV para este depósito.',
                    downloadStarted: 'Download iniciado.',
                    errorConfig: 'Erro ao carregar configuração.',
                    errorList: 'Erro ao carregar lista.',
                    errorToken: 'Erro ao obter link de download.',
                    errorDownload: 'Erro ao baixar.',
                    depositoActual: 'Depósito atual',
                },
                filters: 'Filtros',
                from: 'Deste',
                until: 'Até',
                sizeGt: 'Tamanho maior que',
                sizeLt: 'Tamanho menor que',
                dashboard: {
                    fileUserMetrics: {
                        title: "Indicadores de arquivo dos últimos 5 meses",
                        countLabel: "Número de arquivos",
                        sizeLabel: "Peso",
                    },
                    almacenamientoPorUsuario: {
                        title: "Armazenamento por usuário (Mb)",
                        subtitle: "Peso total"
                    },
                    cantidadArchivosPorUsuario: {
                        title: "Número de arquivos por usuário",
                        subtitle: "Número de arquivos"
                    }
                }
            },
        }
    }
}

export default messages
